module.exports = require("@justeat/f-button");